module.exports = "/assets/with-account-active.png?lk3IrBZ";